import React from "react";
import ApiResponseVO from "../../../../ts/manager/api/ApiResonseVO";
import {getManager} from "../../../../ts/manager/Manager";
import BasicForm from "../../../component/form/BasicForm";
import AppButton from "../../../element/button/AppButton";
import StateViewController from "../../../vc/StateViewController";
import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";

class AccountLogoutForm extends BasicForm
{

    bindFunctions()
    {
        super.bindFunctions();

        this.logOut = this.logOut.bind(this);
    }

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);
        return await getManager().api.fetchData("/account/logout", "POST", params, true);
    }

    handleSubmitComplete()
    {
        this.logOut();
    }

    logOut()
    {
        getManager().user.logOut();
    }

    renderComponent()
    {

        return <>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form
                            onSubmit={this.handleFormSubmit}
                            className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                        >

                            {this.formAlerts()}
                            {this.requiredFieldsMessage()}
                            <div className="clearfix">
                                <div className="form-group float-start mt-4">
                                    <AppButton
                                        type="submit"
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        disabled={this.isSubmitDisabled()}
                                    >
                                        Log out of all devices
                                    </AppButton>
                                    <AppButton
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        onClick={this.logOut}
                                    >
                                        Log out
                                    </AppButton>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>

        </>;
    }
}

const AccountLogOutPage = (props:IRouteProps) =>
{
    const viewState = StateViewController({
        routeProps: props,
        redirectOnLogout: true
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    return <>
        <section className="content-block">
            <AccountLogoutForm
                routeProps={props}
            />
        </section>
    </>
}

export default AccountLogOutPage;